import * as React from "react";
import { cn } from "./cn";
import { Label } from "./label";

export type FormFieldProps = {
  label?: React.ReactNode;
  optional?: boolean;
  description?: React.ReactNode;
  error?: React.ReactNode;
  htmlFor?: string;
  className?: string;
  /** Right-aligned action node next to the label (e.g. inline helper button). */
  actions?: React.ReactNode;
  children: React.ReactNode;
};

export function FormField({
  label,
  optional,
  description,
  error,
  htmlFor,
  className,
  actions,
  children,
}: FormFieldProps) {
  return (
    <div className={cn("space-y-2", className)}>
      {label || actions ? (
        <div className="flex items-center justify-between gap-3">
          {label ? (
            <Label htmlFor={htmlFor}>
              {label}
              {optional ? (
                <span className="ml-1 font-normal normal-case text-ash">
                  (tuỳ chọn)
                </span>
              ) : null}
            </Label>
          ) : (
            <span />
          )}
          {actions ? <div className="shrink-0">{actions}</div> : null}
        </div>
      ) : null}
      {children}
      {description && !error ? (
        <p className="text-xs text-ash">{description}</p>
      ) : null}
      {error ? (
        <p className="text-xs font-semibold text-danger">{error}</p>
      ) : null}
    </div>
  );
}
